"use client";

import { useState } from "react";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const faqs = [{
  question: "What is the minimum order quantity for commercial accounts?",
  answer: "We require a minimum order of 50 lbs per delivery to ensure the best wholesale pricing and maintain our strict freshness standards from shore to door."
}, {
  question: "How often do you deliver to restaurants and markets?",
  answer: "We offer deliveries three times a week (Monday, Wednesday, Friday) to our commercial partners within our primary Gulf Coast service area. Special arrangements can be made for high-volume accounts."
}, {
  question: "Can I request specific cuts or portion sizes?",
  answer: "Yes, our expert cutters can accommodate custom portioning requests for your specific menu needs. Whether you need whole fish or precise fillets, please discuss your requirements with your dedicated account manager."
}, {
  question: "Do you provide sustainable sourcing documentation?",
  answer: "Absolutely. Every delivery includes full traceability documentation, detailing the catch location, vessel, and date to support your sustainability claims and assure your customers of the highest quality."
}, {
  question: "How do I set up payment terms?",
  answer: "Approved commercial accounts typically start with Net 15 terms, with the possibility to extend to Net 30 based on order volume and payment history. Credit applications are processed within 2-3 business days."
}];
export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section id="wholesale-faq" className="bg-background py-24 md:py-40 px-8 relative overflow-hidden">
      {}
      <div className="absolute left-8 md:left-16 top-0 bottom-0 w-[1px] bg-border/50 hidden md:block" />

      <div className="max-w-[1440px] mx-auto grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-24 relative z-10">
        
        {}
        <div className="lg:col-span-4 flex flex-col items-start">
          <div className="flex items-center gap-4 mb-6">
            <span className="font-mono text-sm tracking-widest text-muted-foreground uppercase">
              04 //
            </span>
            <span className="font-mono text-sm tracking-widest text-foreground uppercase">
              Commercial Inquiries
            </span>
          </div>
          
          <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-semibold text-foreground mb-8 tracking-tight leading-tight">
            Wholesale FAQ
          </h2>
          
          <p className="font-sans text-lg text-foreground/80 mb-10 leading-relaxed">
            Find answers to common questions about partnering with The Miss Yvonne. We are committed to providing premium, wild-caught seafood to restaurants and markets that share our dedication to quality.
          </p>
          
          <Button asChild size="lg" className="bg-secondary text-secondary-foreground font-mono uppercase tracking-wider rounded-md px-10 py-6 hover:bg-foreground hover:text-background transition-colors duration-150 shadow-md">
            <Link to="/CommercialAccountsPage">
              Apply for Account
            </Link>
          </Button>
        </div>

        {}
        <div className="lg:col-span-8 flex flex-col">
          <div className="border-t border-border">
            {faqs.map((faq, i) => <div key={i} data-index={i} className="border-b border-border group">
                <Button onClick={() => toggleFaq(i)} variant="ghost" className="w-full h-auto justify-between items-start py-8 px-0 rounded-md hover:bg-transparent focus-visible:ring-0" aria-expanded={openIndex === i}>
                  <h3 className="font-default text-xl md:text-2xl font-semibold text-foreground pr-8 group-hover:text-primary transition-colors duration-150 text-left">
                    {faq.question}
                  </h3>
                  <div className="shrink-0 w-8 h-8 rounded-md border border-border flex items-center justify-center bg-card group-hover:border-primary transition-colors duration-150 mt-2">
                    <Plus className={`w-5 h-5 text-primary transition-transform duration-300 ease-in-out ${openIndex === i ? 'rotate-45' : ''}`} />
                  </div>
                </Button>
                
                <div className={`grid transition-all duration-300 ease-in-out ${openIndex === i ? 'grid-rows-[1fr] opacity-100 pb-8' : 'grid-rows-[0fr] opacity-0'}`}>
                  <div className="overflow-hidden">
                    <p className="font-sans text-lg text-foreground/80 leading-relaxed max-w-3xl">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </div>)}
          </div>
        </div>

      </div>
    </section>;
}